import React, { useState, useEffect } from 'react';

import {

  Box,

} from '@chakra-ui/react';

import CertificationAnalytics from './Certification';


import Popup from 'components/alerts/Popup';
import OnToast from 'components/alerts/toast';
import { Switch } from '@chakra-ui/react';
import { HashLoader } from 'react-spinners';
interface LearnerActivityData {
  sNo: number;
  lenUserName: string;
  lenMail: string;
  gameTitle: string;
  createdDate: any;
  cohortName: any;
  originalScore: any;
  finalScore: any;
 passed:any,
passAttempts:any,
reAttempts:any,
}

interface RowObj {
   sNo: number;
  lenUserName: string;
  lenMail: string;
  gameTitle: string;
  createdDate: any;
  cohortName: any;
  originalScore: any;
  finalScore: any;
 passed:any,
passAttempts:any,
reAttempts:any,
}

interface LearnerActivityDataTableProps {
  data: RowObj[];
}

const CreatorCreation: React.FC = () => {
  const storage = JSON.parse(localStorage.getItem('user'));


  const [apiData, setApiData] = useState<LearnerActivityData[]>([]);

  const [gameNames, setGames] = useState([]);
  const [cohorts, setcohort] = useState([]);

  const [companyNames, setCompany] = useState([]);
  const [alert, setAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const [deleteId, setDeleteId] = useState<number>(0);

  const [isToggled, setIsToggled] = useState(false);





  const [loadingdata, setLoadingdata] = useState(false);

  const transformData = (apiData: any) => {
    const dataArray = Array.isArray(apiData)
      ? apiData
      : apiData.rows || Object.values(apiData);

    if (!Array.isArray(dataArray)) {
      return [];
    }

    return dataArray.map((data, index) => ({
      ...data,
      sNo: data.sNo,
      lenUserName: data.lenUserName ?? '',
      lenMail: data.lenMail ?? '',
      gameTitle: data.gameTitle ?? '',
      createdDate: data.createdDate ?? '',
      cohortName: data.cohortName ?? '',
      originalScore:data.originalScore ?? '',
      finalScore:data.finalScore?? '',
      passed:data.passed??'',
      passAttempts:data.passAttempts??'',
      reAttempts:data.reattempts??'',
     
     

    
    }));
  };

  const transformedData: RowObj[] = transformData(apiData);

  return (
    <>
      <Box mb={{ base: '135px', md: '100px', xl: '100px' }}></Box>

      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <CertificationAnalytics 
        data={transformedData}
        setApiData={setApiData}
        setCompany={setCompany}
        setGames={setGames}
        setcohort={setcohort}
        apiData={apiData}
        isToggled={isToggled}
        setIsToggled={setIsToggled}
      />

      {isOpen ? (
        <Popup
          setDeleteId={setDeleteId}
          setIsConfirm={setIsConfirm}
          setIsOpen={setIsOpen}
          msg={''}
          setmsg={''}
        />
      ) : null}
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
};

export default CreatorCreation;
